/**
 * Sahifa yangilanganda ish oqimi yo'qolmasligi uchun.
 *
 * Saqlanadigan narsa — faqat **identifikatorlar**. Mijoz ma'lumotlari
 * (F.I.Sh, JSHSHIR, karta) brauzerda qoldirilmaydi: ular serverdan qayta
 * so'raladi. Anketa (1-bosqich) ham saqlanmaydi — u to'ldirilayotgan
 * paytda ichida JSHSHIR va karta raqami bo'ladi.
 *
 * `sessionStorage`, `localStorage` emas: holat vkladkaga bog'lanadi.
 * Yangilash ishni tiklaydi, ikkinchi vkladka esa alohida mijoz bo'lib
 * qoladi. `localStorage` da ikkita vkladka bir-birining holatini
 * yozib ketardi — sotuvchi ikki mijozni parallel yuritsa, ma'lumotlar
 * aralashib ketishi mumkin edi.
 */

const KEY = 'asko.flow';

export interface FlowSnapshot {
  identificationId?: string;
  identificationMode?: 'mock' | 'real';
  clientId?: string;
  sessionId?: string;
  applicationId?: string;
  /**
   * Scoring idempotentlik kaliti. Scoring paytida sahifa yangilansa,
   * takroriy so'rov o'sha kalit bilan ketadi va provayderlarga ikkinchi
   * marta murojaat qilinmaydi (BT §6.8).
   */
  idempotencyKey?: string;
}

export function loadFlow(): FlowSnapshot | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as FlowSnapshot) : null;
  } catch {
    // Buzilgan qiymat — oqimni bloklamasin.
    return null;
  }
}

export function saveFlow(patch: FlowSnapshot): void {
  const next = { ...(loadFlow() ?? {}), ...patch };
  sessionStorage.setItem(KEY, JSON.stringify(next));
}

export function clearFlow(): void {
  sessionStorage.removeItem(KEY);
}
